import React from "react";
import { Helmet } from "react-helmet-async";
import Box from "@mui/material/Box";
import Container from "../../common/Container";
import Banner from "./components/Banner";
import Score from "../Home/components/Score";
import Image from "../../assets/Banner/banner1_2.jpg";
import TheTable from "./components/TheTable";

const styles = {
  paperContainer: {
    height: 350,
    backgroundImage: `url(${Image})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
};

const Latest = () => {
  return (
    <Box>
      <Helmet>
        <title>
          {" "}
          Latest Fiscal Ranking | States Fiscal Transparency League
        </title>
      </Helmet>
      <Box style={styles.paperContainer}>
        <Banner />
      </Box>
      <Box>
        <Container>
          <TheTable />
          <Score />
        </Container>
      </Box>
    </Box>
  );
};

export default Latest;
